export const IMAGE_SLOT_META = [
    { order: 0, role: 'cover', label: 'Selecciona una imagen de portada' },
    { order: 1, role: 'detail', label: 'Selecciona una imagen de detalle' },
    { order: 2, role: 'detail', label: 'Selecciona una imagen de detalle' },
    { order: 3, role: 'detail', label: 'Selecciona una imagen de detalle' },
    { order: 4, role: 'detail', label: 'Selecciona una imagen de detalle' }
]

export const IMAGE_SLOT_LIMIT = IMAGE_SLOT_META.length

export const MAX_IMAGE_SIZE_BYTES = 80 * 1024

export const createEmptyImageSlots = () =>
    IMAGE_SLOT_META.map(meta => ({
        ...meta,
        base64: '',
        preview: '',
        fileName: '',
        remoteUrl: ''
    }))

export const updateSlotAtOrder = (slots, order, data) =>
    slots.map(slot => (slot.order === order ? { ...slot, ...data } : slot))

export const buildElemtsPayloadFromSlots = (slots = []) => {
    const list = slots
        .filter(slot => Boolean(slot.base64))
        .map((slot, idx) => ({
            order: idx,
            active: true,
            des: slot.role,
            image: {
                base: slot.base64,
                name: slot.fileName || `${slot.order}.png`
            }
        }))

    if (!list.length) {
        return [
            {
                order: 0,
                key: 0,
                title: 'Agregar fotos',
                data: {
                    list: [
                        {
                            order: 0,
                            active: false,
                            des: '',
                            image: {
                                base: '',
                                name: ''
                            }
                        }
                    ]
                }
            }
        ]
    }

    return [
        {
            order: 0,
            key: 0,
            title: 'Agregar fotos',
            data: { list }
        }
    ]
}

export const applySlotPayload = (slots, order, payload = {}) => {
    const hasBase64 = Object.prototype.hasOwnProperty.call(payload, 'base64')
    const hasPreview = Object.prototype.hasOwnProperty.call(payload, 'preview')
    const hasRemote = Object.prototype.hasOwnProperty.call(payload, 'remoteUrl')

    return slots.map(slot => {
        if (slot.order !== order) return slot
        const nextBase64 = hasBase64 ? payload.base64 : slot.base64
        const nextPreview = hasPreview ? payload.preview : (hasBase64 ? payload.base64 : slot.preview)
        const nextRemote = hasRemote ? payload.remoteUrl : (hasBase64 ? '' : slot.remoteUrl)
        return {
            ...slot,
            base64: nextBase64,
            preview: nextPreview,
            remoteUrl: nextRemote,
            fileName: payload.fileName || slot.fileName
        }
    })
}
